import { render, staticRenderFns } from "./RoomsC.vue?vue&type=template&id=3e72d37e&"
import script from "./RoomsC.vue?vue&type=script&lang=js&"
export * from "./RoomsC.vue?vue&type=script&lang=js&"
import style0 from "./RoomsC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports